import React from 'react';

function EditCodeStructureModal() {
    return (
        <div>Edit Code Structure</div>
    );
}

export default EditCodeStructureModal;
